import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Box from 'components/Box';
import Flag from 'components/Flag';
import Icon from 'components/Icon';
import PageTitle from 'components/PageTitle';
import ShadedCard from 'components/ShadedCard';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import { MainThumbnailPreviewModalWrapper } from '.';
function Wrapper(props) {
  var id = props.id,
    aspectRatio = props.aspectRatio,
    children = props.children,
    recommendedSize = props.recommendedSize,
    onClose = props.onClose,
    title = props.title;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(MainThumbnailPreviewModalWrapper, {
    id: id,
    onClose: onClose,
    pageSections: children
  }, /*#__PURE__*/React.createElement(PageTitle, {
    size: "large",
    mb: "s"
  }, title), /*#__PURE__*/React.createElement(ShadedCard, {
    px: "m",
    py: "s",
    width: "100%",
    maxWidth: 550
  }, /*#__PURE__*/React.createElement(Flag, {
    token: /*#__PURE__*/React.createElement(Icon, {
      name: "info",
      scale: 1.5
    }),
    spacing: "s"
  }, /*#__PURE__*/React.createElement("p", null, t('thumbnail_preview_aspect_ratio'), ":", ' ', /*#__PURE__*/React.createElement("b", null, aspectRatio), /*#__PURE__*/React.createElement("br", null), recommendedSize && /*#__PURE__*/React.createElement(React.Fragment, null, t('thumbnail_preview_recommended_file_size'), ":", ' ', /*#__PURE__*/React.createElement("b", null, recommendedSize)))), /*#__PURE__*/React.createElement(Box, {
    my: "xs",
    borderBottom: "thin"
  }), /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "s"
  }, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "thumbnail_preview_view_guide"
  }, "Please also view the", /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    href: "https://docs.5app.com/guides/creating-artwork",
    target: "_blank"
  }, "Content Artwork Guide"), "on our website and resize your browser window to preview what these components look like across different screen sizes."))));
}
export default Wrapper;